export enum TestExecStatus {
    NOT_STARTED="0",
    IN_PROGRESS="10",
    COMPLETED="20",
    NOT_EXECUTED="30",
    EXCLUDED="50"
}